/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The BoltOptions component
 *
 * @author Thais Watanabe
 */
const BoltOptions = (props) => {
  const { child, position, setChildrenResults, editedChildResults } = props;

  /**
   * hasErrorsChildForm
   * @param {*} position
   */
  function hasErrorsChildForm(position) {
    if (!editedChildResults) {
      return false;
    }
  }

  /**
   * format
   * @param {*} value
   * @param {*} position
   * @returns
   */
  function format(value, position, boltPosition) {
    const split = editedChildResults[position].split(",");

    if (boltPosition === 1) {
      return `${split[0]},${value},${split[2]}`;
    } else {
      return `${split[0]},${split[1]},${value}`;
    }
  }

  return (
    <div position={position} className="flex justify-between gap-4 mb-3">
      <div className="w-full">
        <label
          htmlFor={child.id}
          className="block text-sm font-medium text-gray-900"
        >
          ボルト NO.
        </label>
        <div className="mt-1 relative">
          <input
            type="text"
            id={child.id}
            name={child.id}
            className={`block w-full shadow-sm sm:text-sm rounded-md border-gray-300 bg-gray-50 px-3 text-gray-500`}
            value={
              editedChildResults
                ? parseInt(editedChildResults[position]?.split(",")[0])
                : ""
            }
            disabled={true}
          />
        </div>
      </div>

      <div className="w-full">
        <label
          htmlFor={child.id}
          className="block text-sm font-medium text-gray-900"
        >
          合マークズレ
        </label>
        <div className="mt-1 relative">
          <select
            autoComplete={child.id}
            id={child.id}
            name={child.id}
            className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm"
            value={
              editedChildResults
                ? editedChildResults[position]?.split(",")[1]
                : ""
            }
            onChange={(e) =>
              setChildrenResults(position, format(e.target.value, position, 1))
            }
          >
            <option>あり</option>
            <option>なし</option>
          </select>
        </div>
        {hasErrorsChildForm(position) && (
          <p className="mt-2 text-sm text-red-600" id={"error" + child.id}>
            「合マークズレ」を入力してください
          </p>
        )}
      </div>

      <div className="w-full">
        <label
          htmlFor={child.id}
          className="block text-sm font-medium text-gray-900"
        >
          回転角度
        </label>
        <div className="mt-1 relative">
          <input
            type="text"
            id={child.id}
            name={child.id}
            className={`${
              hasErrorsChildForm(position)
                ? "pr-10 border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-50"
                : "focus:ring-teal-500 focus:border-teal-500 border-gray-300"
            } block w-full shadow-sm sm:text-sm rounded-md`}
            value={
              editedChildResults
                ? editedChildResults[position]?.split(",")[2]
                : ""
            }
            onChange={(e) =>
              setChildrenResults(position, format(e.target.value, position, 2))
            }
          />
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm" id={"unit" + child.id}>
              º
            </span>
          </div>
        </div>
        {hasErrorsChildForm(position) && (
          <p className="mt-2 text-sm text-red-600" id={"error" + child.id}>
            「回転角度」を入力してください
          </p>
        )}
      </div>
    </div>
  );
};

export default BoltOptions;
